import L from 'leaflet';

const SEVERITY_COLOR = {
  fatal: '#C72B1A',
  injury: '#E89622',
  property: '#F5C236',
};

const POLYGON_BASE = {
  weight: 1.5,
  opacity: 0.9,
  fillOpacity: 0.25,
};

export function styleForFeature(feature) {
  const cat = feature?.properties?.atlasCategory;
  switch (cat) {
    case 'crash-hotspot':
      return { ...POLYGON_BASE, color: '#C72B1A', fillColor: '#C72B1A', fillOpacity: 0.22, dashArray: '4 3' };
    case 'event-boundary':
      return { ...POLYGON_BASE, color: '#0B1F3A', fillColor: '#0B1F3A', fillOpacity: 0.12 };
    case 'event-vendor':
      return { ...POLYGON_BASE, color: '#2A6AB8', fillColor: '#2A6AB8', fillOpacity: 0.2 };
    case 'row-corridor':
      return { ...POLYGON_BASE, color: '#D4A437', fillColor: '#D4A437', fillOpacity: 0.4 };
    case 'parcel-affected':
      return { ...POLYGON_BASE, color: '#C72B1A', fillColor: '#C72B1A', fillOpacity: 0.32 };
    case 'easement-utility':
      return { color: '#2A6AB8', weight: 2, dashArray: '6 5', opacity: 0.9 };
    case 'emergency-shelter':
      return { ...POLYGON_BASE, color: '#1D9E75', fillColor: '#1D9E75', fillOpacity: 0.28 };
    case 'hazard-flood':
      return { ...POLYGON_BASE, color: '#2A6AB8', fillColor: '#2A6AB8', fillOpacity: 0.22, dashArray: '5 4' };
    case 'hazard-wildfire':
      return { ...POLYGON_BASE, color: '#C72B1A', fillColor: '#C72B1A', fillOpacity: 0.22, dashArray: '5 4' };
    default:
      return { ...POLYGON_BASE, color: '#6B6B6B', fillColor: '#6B6B6B', fillOpacity: 0.15 };
  }
}

function dot(color, radius = 5, stroke = '#FFFFFF') {
  return (feature, latlng) =>
    L.circleMarker(latlng, {
      radius,
      color: stroke,
      weight: 1.75,
      fillColor: color,
      fillOpacity: 1,
      opacity: 1,
    });
}

function shape(symbol, color, size = 20) {
  return (feature, latlng) => {
    // Solid colored badge with white glyph on top. Readable on any basemap
    // (light, dark, satellite) and keeps the brand palette dominant.
    const html = `<span class="qmd-badge" style="--c:${color};--s:${size}px">${symbol}</span>`;
    return L.marker(latlng, {
      icon: L.divIcon({
        className: 'qmd-divicon',
        html,
        iconSize: [size, size],
        iconAnchor: [size / 2, size / 2],
      }),
    });
  };
}

export function pointToLayerForFeature(feature, latlng) {
  const p = feature.properties || {};
  switch (p.atlasCategory) {
    case 'crash-point': {
      const c = SEVERITY_COLOR[p.severity] || '#6B6B6B';
      return dot(c, p.severity === 'fatal' ? 6 : 4)(feature, latlng);
    }
    case 'event-gate':
      return shape('▲', '#D4A437')(feature, latlng);
    case 'event-medical':
      return shape('+', '#C72B1A')(feature, latlng);
    case 'event-security':
      return shape('■', '#0B1F3A')(feature, latlng);
    case 'permit-point':
      return shape('◆', '#D4A437', 20)(feature, latlng); // gold badge — brand-prominent
    case 'emergency-eoc':
      return shape('★', '#D4A437', 24)(feature, latlng);
    case 'emergency-fire':
      return shape('▲', '#C72B1A', 22)(feature, latlng);
    case 'emergency-ems':
      return shape('■', '#2A6AB8', 22)(feature, latlng);
    case 'emergency-hospital':
      return shape('+', '#1D9E75', 24)(feature, latlng);
    default:
      return dot('#D4A437', 5)(feature, latlng); // gold dot fallback, not grey
  }
}
